'use strict';

angular.module('clientDashboardApp').directive('listingPoints', function ($location) {
  return {
    restrict: 'E',
    scope: {
      metric: '=',
      percent: '='
    },
    template: `
    <span ng-switch="metric.value">
        <span ng-switch-when="undefined" style="color:#DDD;">
            no data
        </span>
        <span ng-switch-default>
            {{percent ? displayPercent(metric.value) : metric.value }}
        </span>
        <metric-delta metric="metric" round-to-int="true"></metric-delta>
    </span>`,
    controller: ($scope) => {
      $scope.displayPercent = (x) => {
        if (x === 0) {
          return '0%'
        } else if (!x) {
          return ''
        } else {
          return Math.round(x * 100) + '%';
        }

      }
    }
  };
});
